import { render, staticRenderFns } from "./parent_search_result.vue?vue&type=template&id=79777156&"
import script from "./parent_search_result.vue?vue&type=script&lang=js&"
export * from "./parent_search_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports